import React, {Component} from 'react';

class TwitterShare extends Component {

  componentDidMount() {
    (function (i, s, o, g, r, a, m) {
      i['TwitterButtonObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://platform.twitter.com/widgets.js', 'twitter');
  }

  render() {
    return (
      <div className="twitter-button">
        <a href="https://twitter.com/share?ref_src=twsrc%5Etfw"
           className="twitter-share-button" data-show-count="false" data-size="large">Tweet</a>
      </div>
    );
  }
}

export default TwitterShare;


// WEBPACK FOOTER //
// ./src/components/TwiiterShare.js